export default "__VITE_ASSET__C51rZu0L__"